/**
 * Shared constants for the roles & permissions panel (#385).
 */

/** Role 1: the template that can never lose its routes nor be assigned by a non-superAdmin. */
export const ID_ROL_SUPER_ADMIN = 1;

/** Page size used to walk the action catalog (service default and store paging). */
export const LIMITE_CATALOGO = 500;

/**
 * Whether the actor may tick `accion`: the plan must enable it and, when the
 * actor catalog is known (`otorgables` is an array), the actor must hold it.
 * `otorgables == null` means "catalog unavailable" → fail-open.
 */
export const esAsignable = (accion, otorgables) =>
  accion.habilitada !== false && (!Array.isArray(otorgables) || otorgables.includes(accion.clave));

/** Management keys protected by the backend anti-lockout rule. */
export const CLAVES_GESTION = [
  "usuarios.roles.crear",
  "usuarios.roles.actualizar",
  "usuarios.roles.eliminar",
  "usuarios.roles.item.acciones.actualizar",
];

/** Action keys the panel gates on (from bisstrack_backend scripts/permisos/salida/claves.json). */
export const ACCIONES = {
  ROL_CREAR: "usuarios.roles.crear", // POST /usuarios/roles
  ROL_ACTUALIZAR: "usuarios.roles.actualizar", // PUT /usuarios/roles/:rolId
  ROL_ELIMINAR: "usuarios.roles.eliminar", // DELETE /usuarios/roles/:rolId
  ROL_CLONAR: "usuarios.roles.item.clonar.crear", // POST /usuarios/roles/:rolId/clonar
  ROL_ACCIONES_ACTUALIZAR: "usuarios.roles.item.acciones.actualizar", // PUT /usuarios/roles/:rolId/acciones
  USUARIO_OVERRIDES_ACTUALIZAR: "usuarios.item.acciones.actualizar", // PUT /usuarios/:userId/acciones
  PANTALLAS_ROL_ACTUALIZAR: "usuarios.roles.item.pantallas.actualizar", // PUT /usuarios/roles/:rolId/pantallas
  CAMBIAR_ROL_USUARIO: "usuarios.item.rol.actualizar", // PUT /usuarios/:userId/rol

  // Compound products production (#544). Keys follow the backend convention
  // (<module>.<resource>[.item].<sub-resource>.<verb>).
  PRODUCCION_CREAR: "productos.productos-compuestos.item.producciones.crear", // POST /productos/productos-compuestos/:id/producciones
  PRODUCCION_PREVIEW: "productos.productos-compuestos.item.produccion.preview.listar", // GET /productos/productos-compuestos/:id/produccion/preview
  PRODUCCIONES_LISTAR: "productos.productos-compuestos.producciones.listar", // GET /productos/productos-compuestos/producciones
  PRODUCCION_ANULAR: "productos.productos-compuestos.producciones.item.anular.crear", // POST /productos/productos-compuestos/producciones/:id/anular
};

export const COLOR_METODO = { GET: "info", POST: "success", PUT: "warning", DELETE: "error" };

export const colorDeMetodo = (metodo) => COLOR_METODO[metodo] || "grey";
